<template>
  <div>
    <NuxtLoadingIndicator />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
// <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">

useHead({
  script: [
    {
      src: "https://www.googletagmanager.com/gtag/js?id=G-GJ3Z74XKNH",
      async: true,
    }, {
      src: 'https://static-s.theckb.com/BusinessMarket/SEO/analytics.js'
    }
  ],
  meta: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }
  ]
})


const router = useRouter()
onClient(() => {
  // 在路由切换完成后滚动到顶部
  router.afterEach((to, from) => {
    if (import.meta.client) {
      nextTick(() => {
        document.querySelector('#layout')?.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  })
})
</script>
